class CartFlyoverItems extends CartItems {
  renderContents(parsedState) {
    this.querySelector(".cart-flyover__inner").classList.contains("is-empty") &&
      this.querySelector(".cart-flyover__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "CartFlyover",
        section: "cart-flyover",
        selector: ".cart-flyover__inner",
      },
      {
        id: "cart-icon-count",
        section: "cart-icon-count",
        selector: ".cart-count-badge",
      },
    ];
  }
}

if (!customElements.get("cart-flyover-items")) {
  customElements.define("cart-flyover-items", CartFlyoverItems);
}
